import {
  createContext,
  useContext,
} from 'react'

const WebsitePolicyContext = createContext()


export function useWebsitePolicy() {
  return useContext(WebsitePolicyContext)
}

export default WebsitePolicyContext
